import { Directive, HostListener, Input } from '@angular/core'
import { Amplitude } from '../../../../injectable'

@Directive({
    selector: '[appTrackClick]'
})
export class TrackClickDirective {
    @Input() metric: string
    @Input() debounceMs: number = 100 // Avoid double or duplicate clicks
    @Input() properties: any | undefined

    constructor(private _amplitude: Amplitude) {}

    @HostListener('click', ['$event'])
    onClick(event: Event) {
        if (this.metric) {
            const targetElement = event.target as HTMLInputElement

            // Check if the clicked element is a checkbox
            if (targetElement.type === 'checkbox') {
                const isChecked = targetElement.checked
                // Log the event with 'checked' property for checkboxes
                this._amplitude.logEventWithDebounce(this.debounceMs, this.metric, {
                    ...this.properties,
                    checked: isChecked
                })
            } else {
                // Log the event for other clickable elements without any additional properties
                this._amplitude.logEventWithDebounce(this.debounceMs, this.metric, this.properties)
            }
        }
    }
}
